import { dynamicWrapper, createRoute } from '@/utils/core';

const routesConfig = app => ({
  path: '/toolbar',
  title: 'DBAdmin - toolbar page',
  component: dynamicWrapper(app, [import('./model')], () => import('./components'))
});

export default app => createRoute(app, routesConfig);



// WEBPACK FOOTER //
// ./src/routes/Widgets/Toolbar/index.js